import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SignInButton from 'components/button/SignInButton';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { Section, Row, Item } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, isInvalid, reduxForm } from 'redux-form';
import validations from 'helpers/forms/validations';

const StyledLink = styled(Link)`
    color: ${ theme.palette.primary1Color };
    min-width: 88px;
    font-size: 1rem;
    text-decoration: none;

    &:hover,
    &:focus {
        color: ${ theme.palette.primary1ColorHover };
    }
`;

const LoginForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        invalid,
        pristine,
        submitting,
        translate,
    } = props;

    return (
        <form onSubmit={ handleSubmit(handleSubmitForm) }>
            <Section>
                <Row>
                    <Item>
                        <Field
                            autoComplete='current-username'
                            component={ RenderTextInputField }
                            disabled={ submitting }
                            label={ translate('auth.login.fields.email') }
                            fullWidth={ true }
                            name='email'
                            type='email'
                        />
                    </Item>
                </Row>

                <Row>
                    <Item>
                        <Field
                            autoComplete='current-password'
                            component={ RenderTextInputField }
                            disabled={ submitting }
                            label={ translate('auth.login.fields.password') }
                            fullWidth={ true }
                            name='password'
                            type='password'
                        />
                    </Item>
                </Row>
            </Section>

            <Section>
                <Row>
                    <StyledLink to='/register'>{ translate('signUp.no_account') }</StyledLink>
                </Row>

                <br />

                <Row>
                    <StyledLink to='/password-forgotten'>{ translate('auth.forgotPassword.title') }</StyledLink>
                </Row>
            </Section>

            <Section>
                <Row>
                    <SignInButton
                        disabled={ pristine || submitting || invalid }
                        fullWidth={ true }
                        loading={ submitting }
                    />
                </Row>
            </Section>
        </form>
    );
};

LoginForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.email && validations.email(values.email, values, props)) {
                errors.email = translate('forms.required');
            }
            if (!values.password) {
                errors.password = translate('forms.required');
            }
            return errors;
        },
    }),
);

export default enhance(LoginForm);



// WEBPACK FOOTER //
// ./src/pages/login/LoginForm.js